var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7280_38466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7827 10.4348C18.4175 10.4348 17.9653 10.4348 17.2175 10.4348C17.2175 13.3163 14.8815 15.6522 12.0001 15.6522C9.11856 15.6522 6.78273 13.3163 6.78273 10.4348C6.27836 10.4348 5.72181 10.4348 5.21753 10.4348C5.21753 13.5386 7.30234 16.1555 10.1481 16.9614C9.83612 17.5541 9.88365 18.3003 10.3293 18.8565C10.9147 18.3873 11.5208 17.9016 12.0349 17.4897C12.549 17.9017 13.1551 18.3874 13.7404 18.8565C14.1905 18.2948 14.2348 17.5391 13.9125 16.9436C16.7271 16.1179 18.7827 13.5165 18.7827 10.4348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82605 9.91304C7.82605 9.91304 7.82605 12.5217 10.4347 12.5217L10.9565 13.0434H11.9999C11.9999 13.0434 12.5217 11.4782 13.5651 11.4782C13.5651 11.4782 13.5651 10.4348 14.6086 10.4348C15.6521 10.4348 16.1738 10.4348 16.1738 10.4348C16.1738 10.4348 15.6521 8.34779 18.2608 6.78258L17.2173 6.26086C17.2173 6.26086 13.5651 8.86955 10.9565 8.34783V9.39132H9.91297L9.39125 8.8696L7.82605 9.91304Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7280_38466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/cy.c9fbc9cb0de0bebadcae3f5ba830f0f3.svg";
export { ForwardRef as ReactComponent };